module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"fr":{"card-title":"Redirection","card-text":"Votre requête est en cours de vérification, vous allez être redirigé(e) vers le site de l\u0027AISC"},"en":{"card-title":"Redirection","card-text":"Your request is being verified, you will be redirected to the AISC website."}}')
  delete Component.options._Ctor
}
